import { useEffect } from "react";

const ensureMeta = (selector, attributes) => {
  let element = document.querySelector(selector);
  if (!element) {
    element = document.createElement("meta");
    document.head.appendChild(element);
  }
  Object.entries(attributes).forEach(([key, value]) => {
    element.setAttribute(key, value);
  });
};

const ensureLink = (rel, href, extraAttrs = {}) => {
  const extraSelector = extraAttrs.hreflang ? `[hreflang="${extraAttrs.hreflang}"]` : "";
  let link = document.querySelector(`link[rel="${rel}"]${extraSelector}`);
  if (!link) {
    link = document.createElement("link");
    link.setAttribute("rel", rel);
    document.head.appendChild(link);
  }

  if (extraAttrs.hreflang) {
    link.setAttribute("hreflang", extraAttrs.hreflang);
  }

  link.setAttribute("href", href);
};

const defaultTitle = "La Psicologa Anna";
const defaultDescription =
  "Supporto psicologico professionale a Rieti con la Dott.ssa Anna Antoniozzi.";

/**
 * @param {{title?: string, description?: string, image?: string, canonicalPath?: string}} param0
 */
const useSEO = ({ title, description, image, canonicalPath }) => {
  useEffect(() => {
    const baseUrl = process.env.REACT_APP_SITE_URL || window.location.origin;
    const canonicalUrl = new URL(
      canonicalPath || `${window.location.pathname}${window.location.search}`,
      baseUrl
    ).toString();
    const ogImage = image || process.env.REACT_APP_OG_IMAGE || `${baseUrl}/logo512.png`;
    const computedTitle = title || defaultTitle;
    const computedDescription = description || defaultDescription;

    document.title = computedTitle;

    ensureMeta('meta[name="description"]', {
      name: "description",
      content: computedDescription,
    });

    ensureLink("canonical", canonicalUrl);
    ensureLink("alternate", canonicalUrl, { hreflang: "it-IT" });
    ensureLink("alternate", canonicalUrl, { hreflang: "x-default" });

    ensureMeta('meta[property="og:title"]', {
      property: "og:title",
      content: computedTitle,
    });
    ensureMeta('meta[property="og:description"]', {
      property: "og:description",
      content: computedDescription,
    });
    ensureMeta('meta[property="og:url"]', {
      property: "og:url",
      content: canonicalUrl,
    });
    ensureMeta('meta[property="og:type"]', {
      property: "og:type",
      content: "website",
    });
    ensureMeta('meta[property="og:image"]', {
      property: "og:image",
      content: ogImage,
    });
    ensureMeta('meta[property="og:site_name"]', {
      property: "og:site_name",
      content: defaultTitle,
    });
    ensureMeta('meta[property="og:locale"]', {
      property: "og:locale",
      content: "it_IT",
    });

    ensureMeta('meta[name="twitter:card"]', {
      name: "twitter:card",
      content: "summary_large_image",
    });
    ensureMeta('meta[name="twitter:title"]', {
      name: "twitter:title",
      content: computedTitle,
    });
    ensureMeta('meta[name="twitter:description"]', {
      name: "twitter:description",
      content: computedDescription,
    });
    ensureMeta('meta[name="twitter:image"]', {
      name: "twitter:image",
      content: ogImage,
    });
  }, [title, description, image, canonicalPath]);
};

export default useSEO;
